import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import ItemServiceV2 from "../../../../services/human_resource_appCommonService";
import ItemService from "../../../../services/customer_appCommonService";
import toast from "react-hot-toast";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import { useDispatch, useSelector } from "react-redux";
import { getTodaysData } from "../../../../common/Validations";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import HRConstants from "../../../../common/HRConstants";
import { useNavigate } from "react-router-dom";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import { useRef } from "react";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import { getCashExpenses } from "../../../../redux/feature/hr_app/hrSlice";
const ReceiptsDetails = React.forwardRef((props, ref) => {
  let userData = useSelector((state) => state?.user?.data);
  let cashExpensesNr = useSelector(
    (state) => state?.hr?.cashExpenses?.cashExpensesNr,
  );
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const historyGuardRef = useRef(false);
  const initialFormRef = useRef(null);
  // eslint-disable-next-line 
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  const [getCompanyCode, setCompanyCode] = useState([]);
  const [getTransactionType, setTransactionType] = useState();
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [isDraftSaving, setIsDraftSaving] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const modalData = {
    title: "Expense Updated",
    successMsg: "",
  };
  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);

    if (props.onSuccess) {
      props.onSuccess(); // triggers parent's refetch with correct queryName/page/per_page
    } else {
      props.onHide();
      dispatch(
        getCashExpenses({
          queryName: "Get_HRFinance_List",
          page: 1,
          per_page: 10,
        }),
      );
      navigate(HRConstants.HR_EXPENSES_LIST);
    }
  };
  /* pop failure modal data*/
  const failureCashRequest = {
    title: "Warning",
    ErrorMsg: "",
  };
  const paymentModeOptions = [
    { id: 1, code: "EK", name: "Cash", description: "Cash desc" },
    { id: 2, code: "BK", name: "Bank", description: "Bank desc" },
  ];
  // const getType = [
  //   { id: 1, code: "DEBIT", name: "Payment", description: "Payment" },
  //   { id: 2, code: "CREDIT", name: "Receipt", description: "Receipt" },
  // ];
  const getCompnayBank = [
    { id: 2, name: "HDFC BANK", code: "BK" },
    { id: 3, name: "UNION BANK OF INDIA", code: "BK" },
    { id: 4, name: "ICICI BANK OF INDIA", code: "BK" },
  ];
  const expenseData = [
    { id: 1, name: "Salary", description: "Salary", code: "SL" },
    { id: 2, name: "EV Charges", description: "EV Charges", code: "EC" },
    {
      id: 3,
      name: "Vehicle Repair and Maintanance",
      description: "Vehicle Repair and Maintanance",
      code: "VRM",
    },
    { id: 4, name: "Diesel", description: "Diesel ", code: "DE" },
    {
      id: 5,
      name: "Telephone and Mobile",
      description: "Telephone and Mobile",
      code: "TMB",
    },
    { id: 6, name: "Miscellaneous", description: "Miscellaneous", code: "ME" },
  ];

  const [getFailureCashRequest] = useState(failureCashRequest);
  // eslint-disable-next-line
  const [getErrorFields, setErrorFields] = useState([]);
  const [getShowFailureModal, setShowFailureCashRequest] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  // eslint-disable-next-line 
  const [getCustomer, setCustomer] = useState([]);
  const [formInputs, setFormInputs] = useState({
    createdBy: userData?.userId || "",
    expenseCreatedDate: "",
    companyCode: "",
    expenseName: "",
    paymentMode: "",
    bankName: "",
    bankTransactionDate: "",
    chequeNumber: "",
    chequeDate: "",
    transactionMode: "",
    expensesHead: "",
    expenseAmount: "",
    expenseAmountInWords: "",
    customerCode: "",
    receiverContactNumber: "",
    paymentPurpose: "",
  });
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };
  //Validations
  const [validation, setValidation] = useState({
    companyCode: "",
    expenseName: "",
    paymentMode: "",
    bankName: "",
    bankTransactionDate: "",
    chequeNumber: "",
    chequeDate: "",
    transactionMode: "",
    expensesHead: "",
    expenseAmount: "",
    expenseAmountInWords: "",
    customerCode: "",
    receiverContactNumberL: "",
    paymentPurpose: "",
  });
  useEffect(() => {
    const loadMasterData = async () => {
      let obj1 = {
        codeType: "companyCode",
      };
      await ItemService.getMasterData(obj1).then((item) => {
        // console.log(">> item! companyCode title", item);
        if (item?.status === 200) {
          setCompanyCode(item?.data);
        } else {
          setCompanyCode([]);
          console.log(">> Error: Loading Company Code");
        }
      });

      let obj2 = {
        queryName: "AllCustomers",
        page: 1,
        per_page: 10,
        rowFilter: {
          $and: [
            {
              type: "EMP",
            },
          ],
        },
      };

      await ItemService.generateCustomerQuery(obj2).then((item) => {
        if (item?.status === 200) {
          const transformed = item.data.map((cust) => ({
            id: cust.customerCode,
            name: cust.organisationName,
            desc: cust.organisationName,
            customerBandkDetails: cust.bandkDetails?.[0] || null,
            undercategory: cust?.undercategory,
            undercategoryCode: cust?.undercategoryCode,
            receiverContactNumber: cust?.mobileNr,
          }));
          setCustomer(transformed);
        } else {
          setCustomer([]);
          console.log(">> Error: Loading getCustomers");
        }
      });
    };
    loadMasterData();
  }, []);

  //getting customer name
  useEffect(() => {
    setFormInputs({
      createdBy: userData?.userId || "",
      expenseCreatedDate: getTodaysData() || "",
      companyCode: "",
      expenseName: "",
      paymentMode: "",
      bankName: "",
      bankTransactionDate: "",
      chequeNumber: "",
      chequeDate: "",
      transactionMode: "",
      expensesHead: "",
      expenseAmount: "",
      expenseAmountInWords: "",
      customerCode: "",
      receiverContactNumberL: "",
      paymentPurpose: "",
    });
  }, [userData]);
  //Customer drop down
  useEffect(() => {
    if (getDropdownData?.textCode === "customerCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapDocumentNumber: getDropdownData?.sapDocumentNumber,
        customerBandkDetails: getDropdownData?.customerBandkDetails,
        undercategory: getDropdownData?.undercategory,
        undercategoryCode: getDropdownData?.undercategoryCode,
        receiverContactNumber: getDropdownData?.receiverContactNumber,
      }));
    } else if (getDropdownData?.textField === "party") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "paymentMode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      setTransactionType(getDropdownData?.code);
      // getProjectDetailsByCode(getDropdownData?.id);
    } else if (getDropdownData?.textField === "expenseName") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    } else if (getDropdownData?.textField === "type") {
      setFormInputs((prev) => {
        const updated = {
          ...prev,
          [getDropdownData?.textField]: getDropdownData?.code,
          [getDropdownData?.textDesc]: getDropdownData?.description,
        };

        // ✅ Always use the current expenseAmount (not stale prev.expenseAmount)
        const currentAmount = Number(prev.expenseAmount) || 0;

        if (currentAmount > 0) {
          if (getDropdownData?.code === "CREDIT") {
            updated.creditAmount = currentAmount;
            updated.debitAmount = 0;
          } else if (getDropdownData?.code === "DEBIT") {
            updated.debitAmount = currentAmount;
            updated.creditAmount = 0;
          }
        }

        return updated;
      });

      // setPaymentType(getDropdownData?.code);
    } else if (getDropdownData?.textCode === "projectNameCode") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.id,
        [getDropdownData?.textDesc]: getDropdownData?.description,
        sapProjectCode: getDropdownData?.sapProjectCode,
      }));
      // getProjectDetailsByCode(getDropdownData?.id);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getDropdownData]);
  const loadFirstLevelData = async (page) => {
    if (cashExpensesNr) {
      let obj = {
        queryName: "Get_HRFinance_Details",
        documentNumber: cashExpensesNr,
      };
      await ItemService.generateCustomerQuery(obj).then((item) => {
        if (item?.status === 200) {
          // setDisabledStatus(true);
          setFormInputs(item?.data[0]);
        } else {
          setFormInputs([]);
          console.log(">> Error: Loading getCategory");
        }
      });
    } else {
      // navigate(Constants.PRESALES_INQUIRY_LIST);
    }
  };
  const handleCancelClick = () => {
    // Restore original form data if available
    if (initialFormRef.current) {
      const originalData = JSON.parse(initialFormRef.current);
      setFormInputs(originalData);
    }
    setIsEditMode(false);
    historyGuardRef.current = false;
  };
  useEffect(() => {
    if (cashExpensesNr) {
      loadFirstLevelData();
    }
    // eslint-disable-next-line
  }, [cashExpensesNr]);
  const handleInputChange = ({ target: { name, value } }) => {
    const errors = {};
    const convertNumberToWords = (num) => {
      if (num === "" || isNaN(num)) return "";
      num = parseFloat(num).toFixed(2); // Ensure two decimal places
      let [rupees, paise] = num.split(".");
      rupees = parseInt(rupees);
      paise = parseInt(paise);

      const ones = [
        "",
        "One",
        "Two",
        "Three",
        "Four",
        "Five",
        "Six",
        "Seven",
        "Eight",
        "Nine",
        "Ten",
        "Eleven",
        "Twelve",
        "Thirteen",
        "Fourteen",
        "Fifteen",
        "Sixteen",
        "Seventeen",
        "Eighteen",
        "Nineteen",
      ];

      const tens = [
        "",
        "",
        "Twenty",
        "Thirty",
        "Forty",
        "Fifty",
        "Sixty",
        "Seventy",
        "Eighty",
        "Ninety",
      ];
      const scales = ["", "Thousand", "Million", "Billion", "Trillion"];
      const convertBelowThousand = (n) => {
        if (n < 20) return ones[n];
        if (n < 100)
          return (
            tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
          );
        return (
          ones[Math.floor(n / 100)] +
          " Hundred" +
          (n % 100 !== 0 ? " " + convertBelowThousand(n % 100) : "")
        );
      };

      let words = "";
      let scaleIndex = 0;

      while (rupees > 0) {
        let part = rupees % 1000;
        if (part !== 0) {
          words =
            convertBelowThousand(part) +
            " " +
            scales[scaleIndex] +
            (words ? " " + words : "");
        }
        rupees = Math.floor(rupees / 1000);
        scaleIndex++;
      }

      words = words.trim() ? words.trim() + " Rupees" : "";

      if (paise > 0) {
        let paiseWords = convertBelowThousand(paise) + " Paise";
        words += " and " + paiseWords;
      }

      return words || "Zero Rupees";
    };

    // Handle expenseAmount logic
    if (name === "expenseAmount") {
      if (!isNaN(value) && value !== "") {
        setFormInputs((prev) => {
          const updated = {
            ...prev,
            expenseAmount: value,
            expenseAmountInWords: convertNumberToWords(value),
          };

          if (prev.type === "CREDIT") {
            updated.creditAmount = value;
            updated.debitAmount = 0;
          } else if (prev.type === "DEBIT") {
            updated.debitAmount = value;
            updated.creditAmount = 0;
          }

          return updated;
        });
      } else {
        setFormInputs((prev) => ({
          ...prev,
          expenseAmount: 0,
          expenseAmountInWords: "",
          debitAmount: "",
          creditAmount: "",
        }));
      }
    } else {
      // default update for other fields
      setFormInputs((prev) => ({
        ...prev,
        [name]: value,
      }));
    }

    setValidation((prev) => ({
      ...prev,
      [name]: errors[name] || "",
    }));
  };

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);
  const hideFailureModal = () => {
    setShowFailureCashRequest(false);
  };
  const handleUpdateClick = () => {
    setIsEditMode(true);
  };
  const handleSaveClick = async () => {
    if (isDraftSaving) return;
    setIsDraftSaving(true);

    try {
      const payload = { ...formInputs };
      const response = await ItemServiceV2.updateExpense(payload);

      if (response?.status === 200) {
        setModalInfo({
          title: "Expense Updated Successfully",
          successMsg: response?.message || "Expense updated successfully",
        });
        setIsEditMode(false);
        setShowSuccessModal(true); // OK button in SuccessRegisterModal will call hideSuccessModal
      } else {
        toast.error(response?.message || "Failed to update expense");
      }
    } catch (error) {
      console.error("Update expense error:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsDraftSaving(false);
    }
  };
  return (
    // backdrop="static"
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Expenses Details
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/* Removed the two fields */}

        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">PR</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle"> Expenses Details</span>
                  <span className="subHeaderTitle">
                    Information about the expenses
                  </span>
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            // label="Created Date"
                            label={
                              <>
                                <i className="bi bi-calendar-date labelIcon"></i>
                                Created Date
                              </>
                            }
                            name="expenseCreatedDate"
                            id="expenseCreatedDate"
                            value={formInputs?.expenseCreatedDate}
                            onChange={handleInputChange}
                            // disabled={true}
                            disabled={!isEditMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            // label="Expense Type"
                            label={
                              <>
                                <i className="bi bi-wallet2 labelIcon"></i>
                                Expense Type
                              </>
                            }
                            placeholder=""
                            data={expenseData}
                            id="expenseName"
                            iconClassName="dropdownIcon"
                            name="expenseName"
                            code="expenseNameCode"
                            description="expenseNameDesc"
                            setValue={formInputs.expenseName || ""}
                            getvalue={setDropdownData}
                            // required={true}
                            disabled={!isEditMode}
                            error={validation.expenseName}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            // label="Company Name"
                            label={
                              <>
                                <i className="bi bi-building labelIcon"></i>
                                Company Name
                              </>
                            }
                            placeholder=""
                            data={getCompanyCode}
                            id="companyCode"
                            iconClassName="dropdownIcon"
                            name="companyCode"
                            code="companyCode"
                            description="companyCodeDesc"
                            setValue={formInputs.companyCode || ""}
                            getvalue={setDropdownData}
                            required={true}
                            disabled={!isEditMode}
                            error={validation.companyCode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            // label="Payment Mode"
                            label={
                              <>
                                <i className="bi bi-credit-card labelIcon"></i>
                                Payment Mode
                              </>
                            }
                            placeholder=""
                            data={paymentModeOptions}
                            id="paymentMode"
                            iconClassName="dropdownIcon"
                            name="paymentMode"
                            code="paymentModeCode"
                            description="paymentModeDesc"
                            setValue={formInputs.paymentMode || ""}
                            getvalue={setDropdownData}
                            required={true}
                            disabled={!isEditMode}
                            // error={validation.companyCode}
                          />
                        </Col>
                        {getTransactionType === "BK" && (
                          <>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              {/* comapny bank name */}

                              <ComboboxField
                                // label="Company Bank Name"
                                label={
                                  <>
                                    <i className="bi bi-bank labelIcon"></i>
                                    Bank Name
                                  </>
                                }
                                placeholder=""
                                data={getCompnayBank}
                                id="bankName"
                                iconClassName="dropdownIcon"
                                name="bankName"
                                code="bankNameCode"
                                description="bankNameDesc"
                                setValue={formInputs.bankName || ""}
                                getvalue={setDropdownData}
                                required={true}
                                disabled={!isEditMode}
                                // error={validation.companyCode}
                              />
                            </Col>
                          </>
                        )}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Cash/Bank Transaction Date"
                            label={
                              <>
                                <i className="bi bi-calendar-check labelIcon"></i>
                                Cash/Bank Transaction Date
                              </>
                            }
                            name="bankTransactionDate"
                            id="bankTransactionDate"
                            type="date"
                            value={formInputs.bankTransactionDate}
                            // error={validation.receivedBy || ""}
                            onChange={handleInputChange || ""}
                            // disabled={true}
                            disabled={!isEditMode}
                          />
                        </Col>
                        {getTransactionType === "BK" && (
                          <>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                // label="Cheque Number"
                                label={
                                  <>
                                    <i className="bi bi-receipt labelIcon"></i>
                                    Cheque Number
                                  </>
                                }
                                placeholder=""
                                name="chequeNumber"
                                id="chequeNumber"
                                error={validation.chequeNumber || ""}
                                value={formInputs.chequeNumber || ""}
                                onChange={handleInputChange}
                                disabled={!isEditMode}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                // label="Cheque Date"
                                label={
                                  <>
                                    <i className="bi bi-calendar-event labelIcon"></i>
                                    Cheque Date
                                  </>
                                }
                                placeholder=""
                                type="date"
                                min={1990}
                                name="chequeDate"
                                id="chequeDate"
                                error={validation.chequeDate || ""}
                                value={formInputs.chequeDate || ""}
                                onChange={handleInputChange}
                                disabled={!isEditMode}
                              />
                            </Col>
                          </>
                        )}

                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Transaction Type"
                            label={
                              <>
                                <i className="bi bi-arrow-left-right labelIcon"></i>
                                Transaction Type
                              </>
                            }
                            placeholder="NEFT/IMPS/RTGS/CASH/UPI"
                            name="transactionMode"
                            id="transactionMode"
                            error={validation.transactionMode || ""}
                            value={formInputs.transactionMode || ""}
                            onChange={handleInputChange}
                            disabled={!isEditMode}
                          />
                        </Col>
                        {getTransactionType === "EK" && (
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              // label="Cash/Expenses Details"
                              label={
                                <>
                                  <i className="bi bi-cash-stack labelIcon"></i>
                                  Cash/Expenses Details
                                </>
                              }
                              placeholder=""
                              name="expensesHead"
                              id="expensesHead"
                              error={validation.expensesHead || ""}
                              value={formInputs.expensesHead || ""}
                              onChange={handleInputChange}
                              disabled={!isEditMode}
                            />
                          </Col>
                        )}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Amount (INR)"
                            label={
                              <>
                                <i className="bi bi-currency-rupee labelIcon"></i>
                                Amount (INR)
                              </>
                            }
                            placeholder="Enter amount"
                            name="expenseAmount"
                            id="expenseAmount"
                            error={validation.expenseAmount || ""}
                            value={formInputs.expenseAmount || ""}
                            onChange={handleInputChange}
                            disabled={!isEditMode}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            // label="Cash Amount in Words"
                            label={
                              <>
                                <i className="bi bi-text-paragraph labelIcon"></i>
                                Cash Amount in Words
                              </>
                            }
                            placeholder="Cash Amount in Words"
                            name="expenseAmountInWords"
                            id="expenseAmountInWords"
                            value={formInputs.expenseAmountInWords || ""}
                            disabled={true} // Read-only field
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Contact Number"
                            label={
                              <>
                                <i className="bi bi-telephone labelIcon"></i>
                                Customer/Vendor/Employee
                              </>
                            }
                            name="expenseReceiverName"
                            id="expenseReceiverName"
                            value={formInputs.expenseReceiverName || ""}
                            onChange={handleInputChange}
                            // disabled={true}
                            disabled={!isEditMode}
                          />
                        </Col>
                        {getTransactionType === "BK" && (
                          <Col
                            xs={12}
                            md={6}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Customer/Vendor/Employee BankName"
                              name="customrBankName"
                              id="customrBankName"
                              value={
                                formInputs?.customerBandkDetails
                                  ?.bankAccountNumber
                              }
                              // error={validation.receivedBy || ""}
                              onChange={handleInputChange || ""}
                              // disabled={true}
                              disabled={!isEditMode}
                            />
                          </Col>
                        )}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Contact Number"
                            label={
                              <>
                                <i className="bi bi-telephone labelIcon"></i>
                                Contact Number
                              </>
                            }
                            name="receiverContactNumber"
                            id="receiverContactNumber"
                            value={formInputs.receiverContactNumber || ""}
                            error={validation.receiverContactNumber || ""}
                            onChange={handleInputChange}
                            // disabled={true}
                            disabled={!isEditMode}
                          />
                        </Col>
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <ComboboxField
                            // label="Type"
                            label={
                              <>
                                <i className="bi bi-tag labelIcon"></i>
                                Type
                              </>
                            }
                            placeholder=""
                            data={getType}
                            id="type"
                            iconClassName="dropdownIcon"
                            name="type"
                            code="typeCode"
                            description="typeCodeDesc"
                            setValue={formInputs.typeCodeDesc || ""}
                            getvalue={setDropdownData}
                            required={true}
                            // error={validation.type}
                          />
                        </Col> */}
                        {/* <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Debit Amount"
                            label={
                              <>
                                <i className="bi bi-arrow-down-circle labelIcon"></i>
                                Debit Amount
                              </>
                            }
                            name="debitAmount"
                            id="debitAmount"
                            value={formInputs.debitAmount ?? 0}
                            // error={validation.type || ""}
                            onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            // label="Credit Amount"
                            label={
                              <>
                                <i className="bi bi-arrow-up-circle labelIcon"></i>
                                Credit Amount
                              </>
                            }
                            name="creditAmount"
                            id="creditAmount"
                            value={formInputs.creditAmount ?? 0}
                            // error={validation.type || ""}
                            onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            // label="Payment Purpose"
                            label={
                              <>
                                <i className="bi bi-chat-left-text labelIcon"></i>
                                Payment Purpose
                              </>
                            }
                            name="paymentPurpose"
                            id="paymentPurpose"
                            value={formInputs.paymentPurpose}
                            error={validation.paymentPurpose || ""}
                            onChange={handleInputChange}
                            // disabled={true}
                            disabled={!isEditMode}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <FileUploadComponent
                            id="suppoertingDoc"
                            name="supportingDoc"
                            label={
                              <>
                                <i className="bi bi-globe labelIcon"></i>
                                Supporting Document
                              </>
                            }
                            allowedTypes={[
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ]}
                            multiple={true} // Change to false for single file selection
                            required={true}
                            onSuccessUpload={onSuccessUploadDocumentType}
                            value={formInputs?.supportingDoc || ""}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={1}
                          lg={1}
                          className="commTopButtonRightLeftPadding d-flex align-items-center"
                        >
                          {(formInputs?.supportingDoc && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.supportingDoc)
                              }
                            />
                          )) ||
                            "--"}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {/* {
              <Row className="my-4 ">
                <Col
                  lg={{ span: 2, offset: 8 }}
                  className="d-flex justify-content-end mt-2"
                >
                  <button
                    className="btnTable btn-danger"
                    onClick={handleCancel}
                    disabled={disabled}
                  >
                    Cancel
                  </button>
                </Col>
                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btn btnTable"
                    disabled={disabled}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                </Col>
              </Row>
            } */}
          </div>
          <Row className="mt-4 mb-2">
            <Col xs={12} className="d-flex justify-content-end gap-2">
              {!isEditMode ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleUpdateClick}
                >
                  <i className="bi bi-pencil-square me-1"></i>
                  Modify
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleSaveClick}
                    disabled={disabled}
                  >
                    Save
                  </button>

                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCancelClick}
                  >
                    Cancel
                  </button>
                </>
              )}
            </Col>
          </Row>
        </div>
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureStockData={getFailureCashRequest}
          requiredfields={getErrorFields}
        />
        <FileViewerModal
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
        />
        <SuccessRegisterModal
          show={getShowSuccessModal}
          onHide={() => hideSuccessModal()}
          modaldata={getModalInfo}
          aftersuccess={HRConstants.HR_EXPENSES_LIST}
        />
      </Modal.Body>
    </Modal>
  );
});

export default ReceiptsDetails;
